import React from 'react';
import MypagePasswordContainer from 'containers/MypagePasswordContainer/MypagePasswordContainer';

export default function MypagePasswordPage() {
    return (
        <MypagePasswordContainer />
    )
}
